// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__6m4Vj","icon_szukaj":"Szukaj_icon_szukaj__QDxn-","icon_clear":"Szukaj_icon_clear__ZH9oV","szukajInput":"Szukaj_szukajInput__HQfwF","icon2":"Szukaj_icon2__m+NEq"};